import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {
        objects: [],
        methods: []
    }
};
export default createReducer(initialState, {
    [actionTypes.GET_OBJECTS_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].objects`, payload),
    [actionTypes.GET_METHODS_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].methods`, payload)
});
